import { render, staticRenderFns } from "./CheckboxesField.vue?vue&type=template&id=1789f61d&scoped=true&"
import script from "./CheckboxesField.vue?vue&type=script&lang=ts&"
export * from "./CheckboxesField.vue?vue&type=script&lang=ts&"
import style0 from "./CheckboxesField.vue?vue&type=style&index=0&id=1789f61d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1789f61d",
  null
  
)

export default component.exports